module.exports = __webpack_public_path__ + "static/img/1.41d8ebbe.gif";